<!-- RAISE NOTICE -->
<template>
    <v-row no-gutters class="fill-height">
        <!-- // * LEFT PANEL -->
        <v-col :cols="GET_panelLayout.leftPanel" >
                <!-- // * FILTERS -->
                <v-row class="mx-2 mt-4 pa-0" no-gutters>
                    <v-col :cols="computedCols">
                        <!-- // * DESCRIPTION -->
                        <v-row no-gutters>
                            <v-col class="px-4" cols="12">
                                <app-text category="content-title">View Files</app-text>
                                <app-text category="tab-text">Here are the files.</app-text>                                                
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col :cols="computedCols">
                        <v-row no-gutters>
                            <v-col cols="4" class="py-2 pl-2">
                                <v-text-field background-color="white" v-model="search" prepend-inner-icon="icons8-search" filled dense :label="$t('filters.search')" clearable hide-details></v-text-field>
                            </v-col>
                            <v-col cols="4" class="pl-2 py-2">
                                <v-select background-color="white" v-model="filter.fileType" :items="fileTypes" item-text="text" item-value="value" filled dense clearable :label="$t('filters.type')" hide-details></v-select>
                            </v-col>
                            <v-col cols="4" class="pl-2 pr-2 py-2">
                                <v-select background-color="white" v-model="sortBy" :items="filteredHeaders" item-text="text" item-value="value" filled clearable dense :label="$t('filters.sortBy')" hide-details></v-select>
                            </v-col>
                        </v-row>
                    </v-col>
                    
                    <!-- // * Filter and Button Row -->
                    <!-- <v-col cols="12" class="mt-2 pl-2 d-flex align-center"> -->
                      <!-- <div> -->
                      <!-- <v-btn-toggle v-model="filter.noticeStatus" multiple color="white" active-class="white" background-color="lightgrey" dense >
                        <v-btn value="LIVE"><v-icon class="success--text icons8-checkmark-yes"></v-icon><span class="success--text caption">LIVE</span></v-btn>
                        <v-btn value="ONHOLD"><v-icon class="error--text icons8-private"></v-icon><span class="error--text caption">ON HOLD</span></v-btn>
                        <v-btn value="PENDING"><v-icon class="grey--text icons8-circle"></v-icon><span class="grey--text caption">PENDING</span></v-btn> 
                        <v-btn value="DRAFT"><v-icon class="grey--text text--lighten-1 icons8-inactive-state"></v-icon><span class="grey--text caption">DRAFT</span></v-btn>
                      </v-btn-toggle> -->
                      <!-- </div> -->
                      <!-- <v-spacer></v-spacer> -->
                    <!-- <div><appbutton :label="$t('buttons.columns')" icon="icons8-select-column" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" @click.native="columnsDialog = true" /></div>
                    <div><appbutton :label="$t('buttons.addDocument')" icon="icons8-project" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" @click.native="openItem({})" /></div>
                    <div><appbutton :label="$t('buttons.export')" icon="icons8-export-csv" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" @click.native="mix_exportDocuments" /></div>
                    </v-col> -->
                    <!-- // * TABLE -->
                    <v-col class="mt-4 px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <v-data-table
                            :headers="filteredHeaders"
                            :items-per-page="computedItemsPerPage"
                            :items="computedTableData"
                            item-key="id"
                            class="elevation-0"
                            hide-default-header
                            :search="search"
                            :custom-filter="MIX_filterOnlyCapsText">
                            <template v-slot:header="{ props }">
                                <th :align="head.align" class="pa-4 font-weight-medium" style="font-size:12px !important;" v-for="(head, index) in props.headers" :key="index">{{ head.text }}</th>
                            </template>                        
                            <template v-slot:[`item.fileURL`]="{ item }">
                                <v-icon @click="openItem(item)">icons8-document</v-icon>
                            </template> 
                        </v-data-table>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="px-0 copyright">
                        <appcopyright  />
                    </v-col>
                </v-row>
        </v-col>
        <!-- // * RIGHT PANEL -->
        <!-- // * DYNAMIC COMPONENT PANEL -->
        <transition
            name="custom-classes-transition"
            enter-active-class="animate__animated animate__fadeIn animate__animated"
            leave-active-class="animate__animated animate__fadeOut animate__animated"
            mode="out-in">
            <rightpanel></rightpanel>
             <!-- <component :is="dynamicComponent" :key="dynamicComponentKey"></component>      -->
        </transition>


    </v-row>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'; // Map Actions / Getters
    export default {
        // * DATA
        data: () => ({
            // SEARCH
            search: '', // Search Table
            // SORT BY
            sortBy: 'fileName', // Default Table Sort
            // FILTERS
            filter: {
                // Default Filters
                // noticeStatus: ['LIVE', 'DRAFT'],
            },
            // TABLE DATA
            tableData: [],
            headers: [
                { text: 'File', value: 'fileURL', sortable: false, align: 'center', hidden: false, hide: false },
                { text: 'ID', value: 'id', sortable: false, align: 'left', hidden: true, hide: true },
                { text: 'Name', value: 'fileName', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'Type', value: 'fileType', align: 'left', sortable: false, hidden: false, hide: false },    
                { text: 'Size', value: 'fileSize', align: 'left', sortable: false, hidden: false, hide: false },  
                { text: 'Created', value: 'createdDateTime', align: 'left', sortable: false, hidden: false, hide: false },
                { text: 'Created By', value: 'createdUserData.userName', align: 'left', sortable: false, hidden: false, hide: true },
                { text: 'Organisation', value: 'createdUserData.organisationName', align: 'left', sortable: false, hidden: false, hide: false },    
                { text: 'Last Modified', value: 'modifiedDateTime', align: 'left', sortable: false, hidden: true, hide: true },
                { text: 'Modified By', value: 'modifiedUserData', align: 'left', sortable: false, hidden: true, hide: true },
            ],

            // SEARCH
            search: '',

            // LOOKUP VALUES
            fileTypes: [],
            fileSeverities: [],
            filteredHeaders: []

 
        }),
        // * COMPUTED
        computed: {
            // Map Getters
            ...mapGetters({
                GET_panelLayout: 'GET_panelLayout',
                GET_currentUser: 'GET_currentUser',
                GET_currentUserData: 'GET_currentUserData',
                GET_lookupValues: 'GET_lookupValues',                
            }),
            computedCols() {
                switch (true) {
                    case (this.GET_panelLayout.leftPanel === 12): return 6
                    case (this.GET_panelLayout.leftPanel === 6): return 12;
                    default: return 12;
                }
            },
            // computedHeaders() {
            //     return (this.$filter(this.headers, {
            //         hidden: false, // filter headers based on initial hidden value
            //     }));
            // },
            computedItemsPerPage() {
                switch(this.$vuetify.breakpoint.name) {
                case 'xs': return 1; break;
                case 'sm': return 5; break;
                case 'md': return 10; break;
                case 'lg': return 6; break;
                case 'xl': return 20; break;
                default: break;
                }
            },
            computedTableData() {
                var t = this;
                var tableData = this.tableData
                // Filter by documentStatus
                // tableData = tableData.filter(function(item) {
                    // return t.filter.noticeStatus.includes(item.noticeStatus);
                // })
                var tableDataList = tableData.map(e => {
                    return {
                        fileURL: e.fileURL,
                        id: e.id,
                        fileName: e.fileName,
                        fileType: e.fileType,
                        fileSize: e.fileSize,
                        createdDateTime: t.MIX_formatDateTime(e.createdDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        createdUserData: e.createdUserData,
                        modifiedDateTime: t.MIX_formatDateTime(e.modifiedDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        modifiedUserData: e.modifiedUserData,
                    };
                });
                // Sort the Table by the Field in the Sort By Filter
                return this.$sortBy(tableDataList, t.sortBy)                
            }
        },
        watch: {
            GET_panelLayout: {
                handler() {
                    let t = this;
                    if (t.GET_panelLayout.rightPanel === 6) {
                        t.filteredHeaders = t.headers.filter((header) => {
                            return (header.hide === false && header.hidden === false);
                        });
                    } else {
                        t.filteredHeaders = t.headers.filter((header) => {
                            return (header.hidden === false);
                        }) 
                    }
                }, deep: true,
            },
            headers: {
                handler() {
                    let t = this;
                     t.filteredHeaders = t.headers.filter((header) => {
                         return (header.hidden === false)
                     });
                }, deep: true,
            }
        },
        // * METHODS
        methods: {
            ...mapActions(['ACT_openFile']),
            // * DEFAULT METHODS
            // Update breadcrumbs
            updateBreadcrumbs() {
                var breadcrumbs = [];
                breadcrumbs.push ({ name: `Files`, path: `/files`}) // Set the Main Path
                breadcrumbs.push ({ name: `View Files`, path: `/files/view-notice`}) // Set the Main Path
                this.MIX_breadcrumbs(breadcrumbs);
            },

            filterOnlyCapsText(value, search, item) {
                return (
                    value != null &&
                    search != null &&
                    typeof value === "string" &&
                    value
                        .toString()
                        .toLocaleUpperCase()
                        .indexOf(search) !== -1
                );
            },
            // Open Project
            openItem() {
                this.MIX_closeView();
                var path = this.$router.currentRoute.path + "/" + this.GET_openDocument.id + '/documents'; // Change the Router Path to Project ID / Documents
                this.$router.push(path).catch((error) => {
                //   console.log(error.message); // Console Log any Errors
                });
            },

            openItem: async function(item) {
                this.dynamicComponentKey++; 
                if (JSON.stringify(item) !== '{}') {
                    var file = await this.MIX_readDocumentById('files', item.id)
                    this.ACT_openFile(file.data);
                } else {
                    this.ACT_openFile({});
                }
                if (this.$vuetify.breakpoint.lgAndDown) {
                    this.MIX_fsDialog(true, 'file');
                    this.MIX_setPanelLayout(12, 0, false, '');
                } else {
                    this.MIX_setPanelLayout(6, 6, true, 'file');
                    // // * HIDE HEADERS
                    // for (var i = 0; i < this.headers.length; i++) {
                    //     if (this.headers[i].hide === true) {
                    //         this.headers[i].hidden = true;
                    //     }
                    // }
                }
                return;
            },
        },
        // * MOUNTED
        async mounted() {
            var t = this;
            this.MIX_setPanelLayout(12, 0, false, ''); // Hide Right Panel
            
            // * LOOKUP RELATED MOUNTED
            await t.MIX_lookupValues(); // LOAD LOOKUP VALUES
            t.noticeTypes = await t.GET_lookupValues('NOTICETYPES');


            // * BREADCRUMB RELATED MOUNTED
            this.updateBreadcrumbs(); // Update Breadcrumbs in Title

            this.$firebase.db.collection('files').onSnapshot(function(querySnapshot) {
                t.tableData = [];
                querySnapshot.forEach(function(doc) {
                    var document = doc.data()
                    document.id = doc.id;
                    t.tableData.push(document);
                });
            });
        },
}
</script>

<style scoped>

/* .copyright {
    position: fixed;
    bottom:10px;
    width: 96%;
    /* width: calc(100% - 56px); 
    padding: 0px;
    margin: 0px !important;   
} */
</style>